import React from 'react';
import PageTitle from '../../components/PageTitle';

const NotAuthorized = () => <PageTitle>Not authorized</PageTitle>;

export default NotAuthorized;
